import React, { useState, useEffect } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { richiediAging } from './funzioni';

const AgingTable = ({ cliente }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function request() {
      setLoading(true);
      const { documenti = [] } = await richiediAging(cliente);
      setData(documenti);
      setLoading(false);
    }

    request();
  }, [cliente]);

  if (!cliente) {
    return <p>Prima seleziona un cliente</p>;
  }

  if (loading) {
    return <p>Caricamento</p>;
  }

  return (
    <BootstrapTable
      id="tabella-aging"
      striped
      bootstrap4
      condensed
      wrapperClasses="table-responsive"
      keyField="Id"
      data={data}
      columns={[
        { dataField: 'Esposizione', text: 'Esposizione' },
        { dataField: 'Scaduto', text: 'Scaduto' },
        { dataField: 'Scaduto_0_30GG', text: 'Scaduto 0 30GG' },
        { dataField: 'Scaduto_31_60GG', text: 'Scaduto 31 60GG' },
        { dataField: 'Scaduto_61_90GG', text: 'Scaduto 61 90GG' },
        { dataField: 'Scaduto_91_180GG', text: 'Scaduto 91 180GG' },
        { dataField: 'Oltre_180GG', text: 'Oltre 180GG' },
        { dataField: 'AScadere', text: 'A scadere' },
        { dataField: 'AScadere_0_30GG', text: 'A scadere 0 30GG' },
        { dataField: 'AScadere_31_60GG', text: 'A scadere 31 60GG' },
        { dataField: 'AScadere_61_90GG', text: 'A scadere 61 90GG' },
        { dataField: 'AScadere_91_180GG', text: 'A scadere 91 180GG' },
        { dataField: 'AScadere_Oltre_180GG', text: 'A scadere Oltre 180GG' },
      ].map((e) => ({ ...e, formatter: (cell) => `€ ${cell ? Number(cell).toFixed(2) : 0.0}` }))}
    />
  );
};

export default AgingTable;
